import { PlanItem, SubmittedItem } from '../slice/replenishmentPlan.types.ts'
import { useCallback } from 'react'
import { useLazyGetSubmittedItemsQuery } from '@/core/api/graphql/forshawGraphqlApi.generated.ts'

const useGetSubmittedItems = () => {
  const [getSubmittedItemsQuery] = useLazyGetSubmittedItemsQuery()

  const getSubmittedItems = useCallback(
    async ({
      branchId,
      fromMonth,
      toMonth,
      productIds,
    }: {
      branchId: number
      fromMonth: string
      toMonth: string
      productIds?: number[]
    }): Promise<PlanItem<SubmittedItem>> => {
      const submittedItems: PlanItem<SubmittedItem> = {}

      try {
        const submittedItemsData = await getSubmittedItemsQuery({
          branchId,
          fromMonth,
          toMonth,
          productIds,
        }).unwrap()

        if (submittedItemsData?.submittedItems) {
          submittedItemsData.submittedItems.forEach((item) => {
            const { productId, month, amount } = item

            if (!submittedItems[productId]) {
              submittedItems[productId] = {}
            }

            submittedItems[productId]![month] = { amount }
          })
        }
      } catch (error) {
        console.error('Error fetching submitted items:', error)
      }

      return submittedItems
    },
    [getSubmittedItemsQuery],
  )

  return { getSubmittedItems }
}

export { useGetSubmittedItems }
